import { createActions } from 'redux-actions';

export default createActions({}, 'SET_HELP_PAGE');



// WEBPACK FOOTER //
// ./src/state/actions/help.js